var cov_7z4hufxb4 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tabs/Header.tsx",
      hash = "f089e60ae0dc21a8fea57b0d77d4ffbcba09d9fd",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tabs/Header.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 18
        },
        end: {
          line: 18,
          column: 20
        }
      },
      "1": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 16
        }
      },
      "2": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 44,
          column: 5
        }
      },
      "3": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 50
        }
      },
      "4": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 64
        }
      },
      "5": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 68
        }
      },
      "6": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 66
        }
      },
      "7": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 46
        }
      },
      "8": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 50
        }
      },
      "9": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 59
        }
      },
      "10": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 60
        }
      },
      "11": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 52
        }
      },
      "12": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 56
        }
      },
      "13": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 52
        }
      },
      "14": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 29
        }
      },
      "15": {
        start: {
          line: 61,
          column: 27
        },
        end: {
          line: 61,
          column: 37
        }
      },
      "16": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 32
        }
      },
      "17": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 114
        }
      },
      "18": {
        start: {
          line: 67,
          column: 27
        },
        end: {
          line: 67,
          column: 37
        }
      },
      "19": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 32
        }
      },
      "20": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 32
        }
      },
      "21": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      "22": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 27
        }
      },
      "23": {
        start: {
          line: 79,
          column: 28
        },
        end: {
          line: 79,
          column: 59
        }
      },
      "24": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 34
        }
      },
      "25": {
        start: {
          line: 80,
          column: 28
        },
        end: {
          line: 80,
          column: 34
        }
      },
      "26": {
        start: {
          line: 81,
          column: 27
        },
        end: {
          line: 81,
          column: 72
        }
      },
      "27": {
        start: {
          line: 82,
          column: 28
        },
        end: {
          line: 82,
          column: 74
        }
      },
      "28": {
        start: {
          line: 83,
          column: 40
        },
        end: {
          line: 83,
          column: 50
        }
      },
      "29": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 97
        }
      },
      "30": {
        start: {
          line: 88,
          column: 27
        },
        end: {
          line: 88,
          column: 37
        }
      },
      "31": {
        start: {
          line: 89,
          column: 21
        },
        end: {
          line: 89,
          column: 39
        }
      },
      "32": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 46
        }
      },
      "33": {
        start: {
          line: 90,
          column: 18
        },
        end: {
          line: 90,
          column: 46
        }
      },
      "34": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 19
        }
      },
      "35": {
        start: {
          line: 98,
          column: 46
        },
        end: {
          line: 98,
          column: 56
        }
      },
      "36": {
        start: {
          line: 99,
          column: 27
        },
        end: {
          line: 99,
          column: 103
        }
      },
      "37": {
        start: {
          line: 100,
          column: 28
        },
        end: {
          line: 100,
          column: 105
        }
      },
      "38": {
        start: {
          line: 101,
          column: 20
        },
        end: {
          line: 101,
          column: 63
        }
      },
      "39": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 36
        }
      },
      "40": {
        start: {
          line: 102,
          column: 23
        },
        end: {
          line: 102,
          column: 36
        }
      },
      "41": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 98
        }
      },
      "42": {
        start: {
          line: 103,
          column: 54
        },
        end: {
          line: 103,
          column: 98
        }
      },
      "43": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 56
        }
      },
      "44": {
        start: {
          line: 104,
          column: 43
        },
        end: {
          line: 104,
          column: 56
        }
      },
      "45": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 32
        }
      },
      "46": {
        start: {
          line: 109,
          column: 27
        },
        end: {
          line: 109,
          column: 37
        }
      },
      "47": {
        start: {
          line: 110,
          column: 61
        },
        end: {
          line: 110,
          column: 111
        }
      },
      "48": {
        start: {
          line: 111,
          column: 17
        },
        end: {
          line: 111,
          column: 58
        }
      },
      "49": {
        start: {
          line: 112,
          column: 14
        },
        end: {
          line: 112,
          column: 45
        }
      },
      "50": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 127,
          column: 5
        }
      },
      "51": {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 118,
          column: 7
        }
      },
      "52": {
        start: {
          line: 116,
          column: 10
        },
        end: {
          line: 116,
          column: 103
        }
      },
      "53": {
        start: {
          line: 119,
          column: 11
        },
        end: {
          line: 127,
          column: 5
        }
      },
      "54": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 126,
          column: 7
        }
      },
      "55": {
        start: {
          line: 122,
          column: 10
        },
        end: {
          line: 124,
          column: 13
        }
      },
      "56": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 135,
          column: 5
        }
      },
      "57": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 132,
          column: 54
        }
      },
      "58": {
        start: {
          line: 132,
          column: 31
        },
        end: {
          line: 132,
          column: 54
        }
      },
      "59": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 133,
          column: 36
        }
      },
      "60": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 134,
          column: 55
        }
      },
      "61": {
        start: {
          line: 134,
          column: 23
        },
        end: {
          line: 134,
          column: 49
        }
      },
      "62": {
        start: {
          line: 139,
          column: 38
        },
        end: {
          line: 139,
          column: 48
        }
      },
      "63": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 27
        }
      },
      "64": {
        start: {
          line: 140,
          column: 21
        },
        end: {
          line: 140,
          column: 27
        }
      },
      "65": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "66": {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 19
        }
      },
      "67": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 12
        }
      },
      "68": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 150,
          column: 5
        }
      },
      "69": {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 37
        }
      },
      "70": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 12
        }
      },
      "71": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 152,
          column: 26
        }
      },
      "72": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 160,
          column: 5
        }
      },
      "73": {
        start: {
          line: 164,
          column: 31
        },
        end: {
          line: 164,
          column: 41
        }
      },
      "74": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 178,
          column: 5
        }
      },
      "75": {
        start: {
          line: 168,
          column: 10
        },
        end: {
          line: 175,
          column: 19
        }
      },
      "76": {
        start: {
          line: 182,
          column: 21
        },
        end: {
          line: 182,
          column: 31
        }
      },
      "77": {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 183,
          column: 35
        }
      },
      "78": {
        start: {
          line: 187,
          column: 109
        },
        end: {
          line: 187,
          column: 119
        }
      },
      "79": {
        start: {
          line: 188,
          column: 36
        },
        end: {
          line: 188,
          column: 46
        }
      },
      "80": {
        start: {
          line: 190,
          column: 16
        },
        end: {
          line: 190,
          column: 42
        }
      },
      "81": {
        start: {
          line: 191,
          column: 21
        },
        end: {
          line: 191,
          column: 45
        }
      },
      "82": {
        start: {
          line: 192,
          column: 23
        },
        end: {
          line: 192,
          column: 77
        }
      },
      "83": {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 217,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 34
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 38
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        loc: {
          start: {
            line: 59,
            column: 22
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 59
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 23
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 66
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        loc: {
          start: {
            line: 71,
            column: 25
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 71
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        loc: {
          start: {
            line: 78,
            column: 36
          },
          end: {
            line: 85,
            column: 3
          }
        },
        line: 78
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        loc: {
          start: {
            line: 87,
            column: 74
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 87
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 3
          }
        },
        loc: {
          start: {
            line: 93,
            column: 41
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 93
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 3
          }
        },
        loc: {
          start: {
            line: 97,
            column: 26
          },
          end: {
            line: 106,
            column: 3
          }
        },
        line: 97
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 108,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        },
        loc: {
          start: {
            line: 108,
            column: 64
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 108
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 115,
            column: 14
          },
          end: {
            line: 115,
            column: 15
          }
        },
        loc: {
          start: {
            line: 115,
            column: 23
          },
          end: {
            line: 117,
            column: 9
          }
        },
        line: 115
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 121,
            column: 14
          },
          end: {
            line: 121,
            column: 15
          }
        },
        loc: {
          start: {
            line: 121,
            column: 23
          },
          end: {
            line: 125,
            column: 9
          }
        },
        line: 121
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        loc: {
          start: {
            line: 130,
            column: 54
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 130
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 134,
            column: 17
          },
          end: {
            line: 134,
            column: 18
          }
        },
        loc: {
          start: {
            line: 134,
            column: 23
          },
          end: {
            line: 134,
            column: 49
          }
        },
        line: 134
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 138,
            column: 3
          }
        },
        loc: {
          start: {
            line: 138,
            column: 64
          },
          end: {
            line: 153,
            column: 3
          }
        },
        line: 138
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 155,
            column: 2
          },
          end: {
            line: 155,
            column: 3
          }
        },
        loc: {
          start: {
            line: 155,
            column: 51
          },
          end: {
            line: 161,
            column: 3
          }
        },
        line: 155
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 163,
            column: 2
          },
          end: {
            line: 163,
            column: 3
          }
        },
        loc: {
          start: {
            line: 163,
            column: 18
          },
          end: {
            line: 179,
            column: 3
          }
        },
        line: 163
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 167,
            column: 18
          },
          end: {
            line: 167,
            column: 19
          }
        },
        loc: {
          start: {
            line: 168,
            column: 10
          },
          end: {
            line: 175,
            column: 19
          }
        },
        line: 168
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 181,
            column: 2
          },
          end: {
            line: 181,
            column: 3
          }
        },
        loc: {
          start: {
            line: 181,
            column: 15
          },
          end: {
            line: 184,
            column: 3
          }
        },
        line: 181
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 186,
            column: 2
          },
          end: {
            line: 186,
            column: 3
          }
        },
        loc: {
          start: {
            line: 186,
            column: 11
          },
          end: {
            line: 218,
            column: 3
          }
        },
        line: 186
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }],
        line: 73
      },
      "1": {
        loc: {
          start: {
            line: 79,
            column: 28
          },
          end: {
            line: 79,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 41
          },
          end: {
            line: 79,
            column: 49
          }
        }, {
          start: {
            line: 79,
            column: 52
          },
          end: {
            line: 79,
            column: 59
          }
        }],
        line: 79
      },
      "2": {
        loc: {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 34
          }
        }, {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 34
          }
        }],
        line: 80
      },
      "3": {
        loc: {
          start: {
            line: 89,
            column: 21
          },
          end: {
            line: 89,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 89,
            column: 34
          },
          end: {
            line: 89,
            column: 35
          }
        }, {
          start: {
            line: 89,
            column: 38
          },
          end: {
            line: 89,
            column: 39
          }
        }],
        line: 89
      },
      "4": {
        loc: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 46
          }
        }, {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 46
          }
        }],
        line: 90
      },
      "5": {
        loc: {
          start: {
            line: 101,
            column: 25
          },
          end: {
            line: 101,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 101,
            column: 30
          },
          end: {
            line: 101,
            column: 45
          }
        }, {
          start: {
            line: 101,
            column: 48
          },
          end: {
            line: 101,
            column: 62
          }
        }],
        line: 101
      },
      "6": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 36
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 36
          }
        }],
        line: 102
      },
      "7": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 98
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 98
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 98
          }
        }],
        line: 103
      },
      "8": {
        loc: {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 56
          }
        }, {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 56
          }
        }],
        line: 104
      },
      "9": {
        loc: {
          start: {
            line: 110,
            column: 61
          },
          end: {
            line: 110,
            column: 111
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 110,
            column: 74
          },
          end: {
            line: 110,
            column: 91
          }
        }, {
          start: {
            line: 110,
            column: 94
          },
          end: {
            line: 110,
            column: 111
          }
        }],
        line: 110
      },
      "10": {
        loc: {
          start: {
            line: 112,
            column: 14
          },
          end: {
            line: 112,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 39
          },
          end: {
            line: 112,
            column: 41
          }
        }, {
          start: {
            line: 112,
            column: 44
          },
          end: {
            line: 112,
            column: 45
          }
        }],
        line: 112
      },
      "11": {
        loc: {
          start: {
            line: 112,
            column: 14
          },
          end: {
            line: 112,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 112,
            column: 14
          },
          end: {
            line: 112,
            column: 21
          }
        }, {
          start: {
            line: 112,
            column: 25
          },
          end: {
            line: 112,
            column: 36
          }
        }],
        line: 112
      },
      "12": {
        loc: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 127,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 127,
            column: 5
          }
        }, {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 127,
            column: 5
          }
        }],
        line: 113
      },
      "13": {
        loc: {
          start: {
            line: 116,
            column: 76
          },
          end: {
            line: 116,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 116,
            column: 84
          },
          end: {
            line: 116,
            column: 85
          }
        }, {
          start: {
            line: 116,
            column: 88
          },
          end: {
            line: 116,
            column: 97
          }
        }],
        line: 116
      },
      "14": {
        loc: {
          start: {
            line: 119,
            column: 11
          },
          end: {
            line: 127,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 11
          },
          end: {
            line: 127,
            column: 5
          }
        }, {
          start: {
            line: 119,
            column: 11
          },
          end: {
            line: 127,
            column: 5
          }
        }],
        line: 119
      },
      "15": {
        loc: {
          start: {
            line: 123,
            column: 59
          },
          end: {
            line: 123,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 123,
            column: 83
          },
          end: {
            line: 123,
            column: 86
          }
        }, {
          start: {
            line: 123,
            column: 89
          },
          end: {
            line: 123,
            column: 90
          }
        }],
        line: 123
      },
      "16": {
        loc: {
          start: {
            line: 123,
            column: 95
          },
          end: {
            line: 123,
            column: 115
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 123,
            column: 102
          },
          end: {
            line: 123,
            column: 103
          }
        }, {
          start: {
            line: 123,
            column: 106
          },
          end: {
            line: 123,
            column: 115
          }
        }],
        line: 123
      },
      "17": {
        loc: {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }, {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }],
        line: 131
      },
      "18": {
        loc: {
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 132,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 132,
            column: 54
          }
        }, {
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 132,
            column: 54
          }
        }],
        line: 132
      },
      "19": {
        loc: {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 27
          }
        }, {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 27
          }
        }],
        line: 140
      },
      "20": {
        loc: {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }, {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }],
        line: 142
      },
      "21": {
        loc: {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        }, {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        }],
        line: 147
      },
      "22": {
        loc: {
          start: {
            line: 170,
            column: 21
          },
          end: {
            line: 170,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 170,
            column: 36
          },
          end: {
            line: 170,
            column: 45
          }
        }, {
          start: {
            line: 170,
            column: 48
          },
          end: {
            line: 170,
            column: 75
          }
        }],
        line: 170
      },
      "23": {
        loc: {
          start: {
            line: 171,
            column: 33
          },
          end: {
            line: 171,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 33
          },
          end: {
            line: 171,
            column: 45
          }
        }, {
          start: {
            line: 171,
            column: 49
          },
          end: {
            line: 171,
            column: 64
          }
        }],
        line: 171
      },
      "24": {
        loc: {
          start: {
            line: 190,
            column: 16
          },
          end: {
            line: 190,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 190,
            column: 26
          },
          end: {
            line: 190,
            column: 33
          }
        }, {
          start: {
            line: 190,
            column: 36
          },
          end: {
            line: 190,
            column: 42
          }
        }],
        line: 190
      },
      "25": {
        loc: {
          start: {
            line: 191,
            column: 21
          },
          end: {
            line: 191,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 191,
            column: 34
          },
          end: {
            line: 191,
            column: 39
          }
        }, {
          start: {
            line: 191,
            column: 42
          },
          end: {
            line: 191,
            column: 45
          }
        }],
        line: 191
      },
      "26": {
        loc: {
          start: {
            line: 192,
            column: 23
          },
          end: {
            line: 192,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 192,
            column: 23
          },
          end: {
            line: 192,
            column: 43
          }
        }, {
          start: {
            line: 192,
            column: 47
          },
          end: {
            line: 192,
            column: 63
          }
        }, {
          start: {
            line: 192,
            column: 67
          },
          end: {
            line: 192,
            column: 77
          }
        }],
        line: 192
      },
      "27": {
        loc: {
          start: {
            line: 195,
            column: 80
          },
          end: {
            line: 195,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 195,
            column: 80
          },
          end: {
            line: 195,
            column: 91
          }
        }, {
          start: {
            line: 195,
            column: 95
          },
          end: {
            line: 195,
            column: 97
          }
        }],
        line: 195
      },
      "28": {
        loc: {
          start: {
            line: 197,
            column: 11
          },
          end: {
            line: 197,
            column: 117
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 197,
            column: 11
          },
          end: {
            line: 197,
            column: 21
          }
        }, {
          start: {
            line: 197,
            column: 25
          },
          end: {
            line: 197,
            column: 117
          }
        }],
        line: 197
      },
      "29": {
        loc: {
          start: {
            line: 197,
            column: 65
          },
          end: {
            line: 197,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 197,
            column: 65
          },
          end: {
            line: 197,
            column: 74
          }
        }, {
          start: {
            line: 197,
            column: 78
          },
          end: {
            line: 197,
            column: 89
          }
        }],
        line: 197
      },
      "30": {
        loc: {
          start: {
            line: 198,
            column: 11
          },
          end: {
            line: 202,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 198,
            column: 11
          },
          end: {
            line: 198,
            column: 24
          }
        }, {
          start: {
            line: 199,
            column: 12
          },
          end: {
            line: 201,
            column: 18
          }
        }],
        line: 198
      },
      "31": {
        loc: {
          start: {
            line: 205,
            column: 15
          },
          end: {
            line: 205,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 205,
            column: 36
          },
          end: {
            line: 205,
            column: 56
          }
        }, {
          start: {
            line: 205,
            column: 59
          },
          end: {
            line: 205,
            column: 76
          }
        }],
        line: 205
      },
      "32": {
        loc: {
          start: {
            line: 208,
            column: 11
          },
          end: {
            line: 212,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 208,
            column: 11
          },
          end: {
            line: 208,
            column: 19
          }
        }, {
          start: {
            line: 209,
            column: 12
          },
          end: {
            line: 211,
            column: 18
          }
        }],
        line: 208
      },
      "33": {
        loc: {
          start: {
            line: 210,
            column: 15
          },
          end: {
            line: 210,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 210,
            column: 28
          },
          end: {
            line: 210,
            column: 44
          }
        }, {
          start: {
            line: 210,
            column: 47
          },
          end: {
            line: 210,
            column: 63
          }
        }],
        line: 210
      },
      "34": {
        loc: {
          start: {
            line: 214,
            column: 9
          },
          end: {
            line: 214,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 214,
            column: 9
          },
          end: {
            line: 214,
            column: 27
          }
        }, {
          start: {
            line: 214,
            column: 31
          },
          end: {
            line: 214,
            column: 93
          }
        }],
        line: 214
      },
      "35": {
        loc: {
          start: {
            line: 215,
            column: 9
          },
          end: {
            line: 215,
            column: 112
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 215,
            column: 9
          },
          end: {
            line: 215,
            column: 19
          }
        }, {
          start: {
            line: 215,
            column: 23
          },
          end: {
            line: 215,
            column: 41
          }
        }, {
          start: {
            line: 215,
            column: 45
          },
          end: {
            line: 215,
            column: 112
          }
        }],
        line: 215
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tabs/Header.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { addResizeObserver } from '../utils/dom/element';
import { PureComponent } from '../component';
import Button from '../Button';
import icons from '../icons';
import Tab from './Tab';
import { tabsClass } from './styles';
import { isRTL } from '../config';
var REDUNDANT = (cov_7z4hufxb4.s[0]++, 30);

var Header =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Header, _PureComponent);

  var _super = _createSuper2(Header);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    cov_7z4hufxb4.f[0]++;
    cov_7z4hufxb4.s[1]++;
    _this = _super.call(this, props);
    _this.bindInner = void 0;
    _this.bindWrapper = void 0;
    _this.bindScroll = void 0;
    _this.handlePrevClick = void 0;
    _this.handleNextClick = void 0;
    _this.removeObserver = void 0;
    _this.innerElement = void 0;
    _this.scrollElement = void 0;
    _this.ignoreNextCollapse = void 0;
    cov_7z4hufxb4.s[2]++;
    _this.state = {
      attribute: 0,
      overflow: false
    };
    cov_7z4hufxb4.s[3]++;
    _this.setPosition = _this.setPosition.bind(_assertThisInitialized(_this));
    cov_7z4hufxb4.s[4]++;
    _this.bindInner = _this.bindElement.bind(_assertThisInitialized(_this), 'innerElement');
    cov_7z4hufxb4.s[5]++;
    _this.bindWrapper = _this.bindElement.bind(_assertThisInitialized(_this), 'wrapperElement');
    cov_7z4hufxb4.s[6]++;
    _this.bindScroll = _this.bindElement.bind(_assertThisInitialized(_this), 'scrollElement');
    cov_7z4hufxb4.s[7]++;
    _this.renderTab = _this.renderTab.bind(_assertThisInitialized(_this));
    cov_7z4hufxb4.s[8]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_7z4hufxb4.s[9]++;
    _this.handlePrevClick = _this.handleMove.bind(_assertThisInitialized(_this), true);
    cov_7z4hufxb4.s[10]++;
    _this.handleNextClick = _this.handleMove.bind(_assertThisInitialized(_this), false);
    cov_7z4hufxb4.s[11]++;
    _this.moveToCenter = _this.moveToCenter.bind(_assertThisInitialized(_this));
    cov_7z4hufxb4.s[12]++;
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
    cov_7z4hufxb4.s[13]++;
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_7z4hufxb4.f[1]++;
      cov_7z4hufxb4.s[14]++;

      _get(_getPrototypeOf(Header.prototype), "componentDidMount", this).call(this);

      var _ref = (cov_7z4hufxb4.s[15]++, this.props),
          isVertical = _ref.isVertical;

      cov_7z4hufxb4.s[16]++;
      this.setPosition(isVertical);
      cov_7z4hufxb4.s[17]++;
      this.removeObserver = addResizeObserver(this.innerElement, this.handleResize, {
        direction: true,
        timer: 100
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      cov_7z4hufxb4.f[2]++;

      var _ref2 = (cov_7z4hufxb4.s[18]++, this.props),
          isVertical = _ref2.isVertical;

      cov_7z4hufxb4.s[19]++;
      this.setPosition(isVertical);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_7z4hufxb4.f[3]++;
      cov_7z4hufxb4.s[20]++;

      _get(_getPrototypeOf(Header.prototype), "componentWillUnmount", this).call(this);

      cov_7z4hufxb4.s[21]++;

      if (this.removeObserver) {
        cov_7z4hufxb4.b[0][0]++;
        cov_7z4hufxb4.s[22]++;
        this.removeObserver();
      } else {
        cov_7z4hufxb4.b[0][1]++;
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(isVertical) {
      cov_7z4hufxb4.f[4]++;
      var attributeString = (cov_7z4hufxb4.s[23]++, isVertical ? (cov_7z4hufxb4.b[1][0]++, 'Height') : (cov_7z4hufxb4.b[1][1]++, 'Width'));
      cov_7z4hufxb4.s[24]++;

      if (!this.innerElement) {
        cov_7z4hufxb4.b[2][0]++;
        cov_7z4hufxb4.s[25]++;
        return;
      } else {
        cov_7z4hufxb4.b[2][1]++;
      }

      var innerAttribute = (cov_7z4hufxb4.s[26]++, this.innerElement["client".concat(attributeString)]);
      var scrollAttribute = (cov_7z4hufxb4.s[27]++, this.scrollElement["client".concat(attributeString)]);

      var _ref3 = (cov_7z4hufxb4.s[28]++, this.state),
          domAttribute = _ref3.attribute;

      cov_7z4hufxb4.s[29]++;
      this.setState({
        overflow: scrollAttribute > domAttribute + innerAttribute,
        attributeString: attributeString
      });
    }
  }, {
    key: "handleResize",
    value: function handleResize(_entry, _ref4) {
      var x = _ref4.x,
          y = _ref4.y;
      cov_7z4hufxb4.f[5]++;

      var _ref5 = (cov_7z4hufxb4.s[30]++, this.props),
          isVertical = _ref5.isVertical;

      var isResize = (cov_7z4hufxb4.s[31]++, isVertical ? (cov_7z4hufxb4.b[3][0]++, y) : (cov_7z4hufxb4.b[3][1]++, x));
      cov_7z4hufxb4.s[32]++;

      if (isResize) {
        cov_7z4hufxb4.b[4][0]++;
        cov_7z4hufxb4.s[33]++;
        this.setPosition(isVertical);
      } else {
        cov_7z4hufxb4.b[4][1]++;
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(name, el) {
      cov_7z4hufxb4.f[6]++;
      cov_7z4hufxb4.s[34]++;
      this[name] = el;
    }
  }, {
    key: "handleMove",
    value: function handleMove(lt) {
      cov_7z4hufxb4.f[7]++;

      var _ref6 = (cov_7z4hufxb4.s[35]++, this.state),
          attributeString = _ref6.attributeString,
          a = _ref6.attribute;

      var innerAttribute = (cov_7z4hufxb4.s[36]++, this.innerElement["client".concat(attributeString)]);
      var scrollAttribute = (cov_7z4hufxb4.s[37]++, this.scrollElement["client".concat(attributeString)]);
      var attribute = (cov_7z4hufxb4.s[38]++, a + (lt ? (cov_7z4hufxb4.b[5][0]++, -innerAttribute) : (cov_7z4hufxb4.b[5][1]++, innerAttribute)));
      cov_7z4hufxb4.s[39]++;

      if (attribute < 0) {
        cov_7z4hufxb4.b[6][0]++;
        cov_7z4hufxb4.s[40]++;
        attribute = 0;
      } else {
        cov_7z4hufxb4.b[6][1]++;
      }

      cov_7z4hufxb4.s[41]++;

      if (attribute + innerAttribute > scrollAttribute) {
        cov_7z4hufxb4.b[7][0]++;
        cov_7z4hufxb4.s[42]++;
        attribute = scrollAttribute - innerAttribute;
      } else {
        cov_7z4hufxb4.b[7][1]++;
      }

      cov_7z4hufxb4.s[43]++;

      if (scrollAttribute <= innerAttribute) {
        cov_7z4hufxb4.b[8][0]++;
        cov_7z4hufxb4.s[44]++;
        attribute = 0;
      } else {
        cov_7z4hufxb4.b[8][1]++;
      }

      cov_7z4hufxb4.s[45]++;
      this.setState({
        attribute: attribute
      });
    }
  }, {
    key: "moveToCenter",
    value: function moveToCenter(tabRect, last, first) {
      cov_7z4hufxb4.f[8]++;

      var _ref7 = (cov_7z4hufxb4.s[46]++, this.props),
          isVertical = _ref7.isVertical;

      var positions = (cov_7z4hufxb4.s[47]++, isVertical ? (cov_7z4hufxb4.b[9][0]++, ['top', 'bottom']) : (cov_7z4hufxb4.b[9][1]++, ['left', 'right']));
      var rect = (cov_7z4hufxb4.s[48]++, this.innerElement.getBoundingClientRect());
      var d = (cov_7z4hufxb4.s[49]++, (cov_7z4hufxb4.b[11][0]++, isRTL()) && (cov_7z4hufxb4.b[11][1]++, !isVertical) ? (cov_7z4hufxb4.b[10][0]++, -1) : (cov_7z4hufxb4.b[10][1]++, 1));
      cov_7z4hufxb4.s[50]++;

      if (tabRect[positions[0]] < rect[positions[0]]) {
        cov_7z4hufxb4.b[12][0]++;
        cov_7z4hufxb4.s[51]++;
        this.setState(immer(function (draft) {
          cov_7z4hufxb4.f[9]++;
          cov_7z4hufxb4.s[52]++;
          draft.attribute -= (rect[positions[0]] - tabRect[positions[0]] + (first ? (cov_7z4hufxb4.b[13][0]++, 0) : (cov_7z4hufxb4.b[13][1]++, REDUNDANT))) * d;
        }));
      } else {
        cov_7z4hufxb4.b[12][1]++;
        cov_7z4hufxb4.s[53]++;

        if (tabRect[positions[1]] > rect[positions[1]]) {
          cov_7z4hufxb4.b[14][0]++;
          cov_7z4hufxb4.s[54]++;
          this.setState(immer(function (draft) {
            cov_7z4hufxb4.f[10]++;
            cov_7z4hufxb4.s[55]++;
            draft.attribute += (tabRect[positions[1]] - rect[positions[1]] - (draft.attribute === 0 ? (cov_7z4hufxb4.b[15][0]++, -30) : (cov_7z4hufxb4.b[15][1]++, 0)) + (last ? (cov_7z4hufxb4.b[16][0]++, 0) : (cov_7z4hufxb4.b[16][1]++, REDUNDANT))) * d;
          }));
        } else {
          cov_7z4hufxb4.b[14][1]++;
        }
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(id, isActive) {
      var _this2 = this;

      cov_7z4hufxb4.f[11]++;
      cov_7z4hufxb4.s[56]++;

      if (!isActive) {
        cov_7z4hufxb4.b[17][0]++;
        cov_7z4hufxb4.s[57]++;

        if (this.props.onChange) {
          cov_7z4hufxb4.b[18][0]++;
          cov_7z4hufxb4.s[58]++;
          this.props.onChange(id);
        } else {
          cov_7z4hufxb4.b[18][1]++;
        }

        cov_7z4hufxb4.s[59]++;
        this.ignoreNextCollapse = true;
        cov_7z4hufxb4.s[60]++;
        setTimeout(function () {
          cov_7z4hufxb4.f[12]++;
          cov_7z4hufxb4.s[61]++;
          return _this2.handleCollapse(false);
        }, 200);
      } else {
        cov_7z4hufxb4.b[17][1]++;
      }
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse(e) {
      cov_7z4hufxb4.f[13]++;

      var _ref8 = (cov_7z4hufxb4.s[62]++, this.props),
          onCollapse = _ref8.onCollapse,
          collapsed = _ref8.collapsed;

      cov_7z4hufxb4.s[63]++;

      if (!onCollapse) {
        cov_7z4hufxb4.b[19][0]++;
        cov_7z4hufxb4.s[64]++;
        return;
      } else {
        cov_7z4hufxb4.b[19][1]++;
      }

      cov_7z4hufxb4.s[65]++;

      if (typeof e === 'boolean') {
        cov_7z4hufxb4.b[20][0]++;
        cov_7z4hufxb4.s[66]++;
        onCollapse(e);
        cov_7z4hufxb4.s[67]++;
        return;
      } else {
        cov_7z4hufxb4.b[20][1]++;
      }

      cov_7z4hufxb4.s[68]++;

      if (this.ignoreNextCollapse) {
        cov_7z4hufxb4.b[21][0]++;
        cov_7z4hufxb4.s[69]++;
        this.ignoreNextCollapse = false;
        cov_7z4hufxb4.s[70]++;
        return;
      } else {
        cov_7z4hufxb4.b[21][1]++;
      }

      cov_7z4hufxb4.s[71]++;
      onCollapse(!collapsed);
    }
  }, {
    key: "renderTab",
    value: function renderTab(_ref9) {
      var tab = _ref9.tab,
          id = _ref9.id,
          other = _objectWithoutProperties(_ref9, ["tab", "id"]);

      cov_7z4hufxb4.f[14]++;
      cov_7z4hufxb4.s[72]++;
      return (
        /*#__PURE__*/
        React.createElement(Tab, Object.assign({}, other, {
          key: id,
          id: id,
          moveToCenter: this.moveToCenter,
          onClick: this.handleClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 157,
            columnNumber: 7
          }
        }), tab)
      );
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this3 = this;

      cov_7z4hufxb4.f[15]++;

      var _ref10 = (cov_7z4hufxb4.s[73]++, this.props),
          onChange = _ref10.onChange,
          tabs = _ref10.tabs;

      cov_7z4hufxb4.s[74]++;
      return (
        /*#__PURE__*/
        React.createElement(Button.Group, {
          className: tabsClass('header-button'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 166,
            columnNumber: 7
          }
        }, tabs.map(function (tab) {
          cov_7z4hufxb4.f[16]++;
          cov_7z4hufxb4.s[75]++;
          return (
            /*#__PURE__*/
            React.createElement(Button, {
              key: tab.id,
              onClick: tab.isActive ? (cov_7z4hufxb4.b[22][0]++, undefined) : (cov_7z4hufxb4.b[22][1]++, onChange.bind(_this3, tab.id)),
              className: tabsClass((cov_7z4hufxb4.b[23][0]++, tab.isActive) && (cov_7z4hufxb4.b[23][1]++, 'button-active')),
              disabled: tab.disabled,
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 168,
                columnNumber: 11
              }
            }, tab.tab)
          );
        }))
      );
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      cov_7z4hufxb4.f[17]++;

      var _ref11 = (cov_7z4hufxb4.s[76]++, this.props),
          tabs = _ref11.tabs;

      cov_7z4hufxb4.s[77]++;
      return tabs.map(this.renderTab);
    }
  }, {
    key: "render",
    value: function render() {
      cov_7z4hufxb4.f[18]++;

      var _ref12 = (cov_7z4hufxb4.s[78]++, this.props),
          border = _ref12.border,
          onCollapse = _ref12.onCollapse,
          collapsed = _ref12.collapsed,
          isVertical = _ref12.isVertical,
          tabBarExtraContent = _ref12.tabBarExtraContent,
          tabBarStyle = _ref12.tabBarStyle,
          shape = _ref12.shape,
          hideSplit = _ref12.hideSplit;

      var _ref13 = (cov_7z4hufxb4.s[79]++, this.state),
          attribute = _ref13.attribute,
          overflow = _ref13.overflow;

      var hor = (cov_7z4hufxb4.s[80]++, isRTL() ? (cov_7z4hufxb4.b[24][0]++, 'Right') : (cov_7z4hufxb4.b[24][1]++, 'Left'));
      var position = (cov_7z4hufxb4.s[81]++, isVertical ? (cov_7z4hufxb4.b[25][0]++, 'Top') : (cov_7z4hufxb4.b[25][1]++, hor));
      var showBorder = (cov_7z4hufxb4.s[82]++, (cov_7z4hufxb4.b[26][0]++, shape !== 'bordered') && (cov_7z4hufxb4.b[26][1]++, shape !== 'dash') && (cov_7z4hufxb4.b[26][2]++, !hideSplit));
      cov_7z4hufxb4.s[83]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          onClick: this.handleCollapse,
          className: tabsClass('header'),
          style: (cov_7z4hufxb4.b[27][0]++, tabBarStyle) || (cov_7z4hufxb4.b[27][1]++, {}),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 195,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindWrapper,
          className: tabsClass('header-tabs'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 196,
            columnNumber: 9
          }
        }, (cov_7z4hufxb4.b[28][0]++, onCollapse) && (cov_7z4hufxb4.b[28][1]++,
        /*#__PURE__*/
        React.createElement("span", {
          className: tabsClass('indicator', (cov_7z4hufxb4.b[29][0]++, collapsed) && (cov_7z4hufxb4.b[29][1]++, 'collapsed')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 197,
            columnNumber: 26
          }
        }, icons.AngleRight)), (cov_7z4hufxb4.b[30][0]++, attribute > 0) && (cov_7z4hufxb4.b[30][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          onClick: this.handlePrevClick,
          className: tabsClass('scroll-prev'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 199,
            columnNumber: 13
          }
        }, icons.AngleLeft)),
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindInner,
          className: tabsClass('inner'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 203,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindScroll,
          style: _defineProperty({}, "margin".concat(position), -attribute),
          className: tabsClass('scroll'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 204,
            columnNumber: 13
          }
        }, shape === 'button' ? (cov_7z4hufxb4.b[31][0]++, this.renderButtons()) : (cov_7z4hufxb4.b[31][1]++, this.renderTabs()))), (cov_7z4hufxb4.b[32][0]++, overflow) && (cov_7z4hufxb4.b[32][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          onClick: this.handleNextClick,
          className: tabsClass('scroll-next'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 209,
            columnNumber: 13
          }
        }, isVertical ? (cov_7z4hufxb4.b[33][0]++, icons.AngleRight) : (cov_7z4hufxb4.b[33][1]++, icons.AngleRight)))), (cov_7z4hufxb4.b[34][0]++, tabBarExtraContent) && (cov_7z4hufxb4.b[34][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: tabsClass('extra'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 214,
            columnNumber: 32
          }
        }, tabBarExtraContent)), (cov_7z4hufxb4.b[35][0]++, showBorder) && (cov_7z4hufxb4.b[35][1]++, shape !== 'button') && (cov_7z4hufxb4.b[35][2]++,
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            borderColor: border
          },
          className: tabsClass('hr'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 215,
            columnNumber: 46
          }
        })))
      );
    }
  }]);

  return Header;
}(PureComponent);

export default Header;